import React, {useEffect, useState} from "react";
import {BillingInterface, BillingItemInterface} from "../../../../service/Business/Interfaces/BillingInterface";
import "../FormAtelier.scss";
import formatEuro from "../../../../utils/formatEuro";

type TableBillingItemProps = {
    dataItemBilling: BillingItemInterface[];
    dataBilling: BillingInterface;
    handlerEvent: (listBillingItemAdd: BillingItemInterface[],
                   listBillingItemDel: BillingItemInterface[],
                   listBillingItemModify: BillingItemInterface[]) => void;
};

const TableBillingItem: React.FunctionComponent<TableBillingItemProps> = (props) => {

    const [listBillingItemTable, setListBillingItemTable] = useState<BillingItemInterface[]>(props.dataItemBilling);
    const [dataBilling] = useState<BillingInterface>(props.dataBilling);
    const [listBillingItemAdd, setListBillingItemAdd] = useState<BillingItemInterface[]>([]);
    const [listBillingItemDel, setListBillingItemDel] = useState<BillingItemInterface[]>([]);
    const [listBillingItemModify, setListBillingItemModify] = useState<BillingItemInterface[]>([]);

    const [currentLabel, setCurrentLabel] = useState<string>("");
    const [currentVAT, setCurrentVAT] = useState<string>("");
    const [currentQuantity, setCurrentQuantity] = useState<string>("");
    const [currentUnitPrice, setCurrentUnitPrice] = useState<string>("");

    const [editingRowId, setEditingRowId] = useState<number | null>(null);
    const [cptAdd, setCptAdd] = useState<number>(-1);

    useEffect(() => {
        let listTmp: BillingItemInterface[] = [...props.dataItemBilling, ...listBillingItemAdd];
        for (const del of listBillingItemDel) {
            listTmp = listTmp.filter((row) => row.id !== del.id);
        }
        for (const mod of listBillingItemModify) {
            listTmp = listTmp.map((row) => row.id === mod.id ? {...row, ...mod} : row);
        }
        setListBillingItemTable(listTmp);
        props.handlerEvent(listBillingItemAdd, listBillingItemDel, listBillingItemModify);
    }, [listBillingItemAdd, listBillingItemDel, listBillingItemModify]);

    const addBillingItem = () => {
        const id = cptAdd;
        const newItem: BillingItemInterface = {
            VAT: 0.20, id, label: "Prestation Développement", quantity: 0,
            totalAmountExclTax: 0, totalAmountInclTax: 0,
            unitPrice: dataBilling.businessDeal.details.tjm
        };
        setListBillingItemAdd((prev) => [...prev, newItem]);
        setCptAdd((prev) => prev - 1);
        setEditingRowId(id);
        setCurrentLabel(newItem.label);
        setCurrentVAT(newItem.VAT.toString());
        setCurrentQuantity(newItem.quantity.toString());
        setCurrentUnitPrice(newItem.unitPrice.toString());
    };

    const delBillingItem = (item: BillingItemInterface) => {
        if (item.id <= -1) {
            setListBillingItemAdd((prev) => prev.filter((row) => row.id !== item.id));
        } else {
            setListBillingItemDel((prev) => [...prev, item]);
        }
        if (editingRowId === item.id) setEditingRowId(null);
    };

    const handleSaveRow = (id: number, vat: number, label: string, quantity: number, unitPrice: number) => {
        const totalAmountExclTax = quantity * unitPrice;
        const totalAmountInclTax = totalAmountExclTax * (1 + vat);
        const updated = (row: BillingItemInterface): BillingItemInterface =>
            ({...row, VAT: vat, label, quantity, totalAmountExclTax, totalAmountInclTax, unitPrice});

        const onAdd = listBillingItemAdd.find((b) => b.id === id);
        const onMod = listBillingItemModify.find((b) => b.id === id);

        if (onAdd) {
            setListBillingItemAdd((prev) => prev.map((row) => row.id === id ? updated(row) : row));
        } else if (onMod) {
            setListBillingItemModify((prev) => prev.map((row) => row.id === id ? updated(row) : row));
        } else {
            listBillingItemTable.forEach((row) => {
                if (row.id === id) {
                    setListBillingItemModify((prev) => [...prev, updated(row)]);
                }
            });
        }
    };

    return (
        <div className="ctcWrapper">
            <div style={{display: "flex", justifyContent: "flex-end"}}>
                <button type="button" className="ctcAddBtn" onClick={addBillingItem}>
                    <span className="material-symbols-outlined">add</span>
                    Ajouter une ligne
                </button>
            </div>

            <div className="ctcTableWrapper">
                <table className="ctcTable">
                    <thead>
                    <tr>
                        <th>Description</th>
                        <th>TVA</th>
                        <th>Quantité</th>
                        <th>Prix unitaire</th>
                        <th>Total HT</th>
                        <th>Total TTC</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {listBillingItemTable.length === 0 && (
                        <tr>
                            <td colSpan={7} className="ctcEmptyRow">
                                Aucune ligne — cliquez sur « Ajouter une ligne »
                            </td>
                        </tr>
                    )}
                    {listBillingItemTable.map((e: BillingItemInterface, index: React.Key) => (
                        <tr key={index} className={editingRowId === e.id ? "ctcRowEditing" : ""}>
                            <td>
                                {editingRowId === e.id
                                    ? <input className="ctcInput" type="text"
                                             value={currentLabel}
                                             onChange={(ev) => {
                                                 setCurrentLabel(ev.target.value);
                                                 handleSaveRow(e.id, e.VAT, ev.target.value, e.quantity, e.unitPrice);
                                             }}/>
                                    : <span className="ctcCellName">{e.label}</span>
                                }
                            </td>
                            <td>
                                {editingRowId === e.id
                                    ? <input className="ctcInput" type="text" style={{width: 70}}
                                             value={currentVAT}
                                             placeholder="0.20"
                                             onChange={(ev) => {
                                                 const v = ev.target.value.replaceAll(',', '.');
                                                 const n = parseFloat(v);
                                                 setCurrentVAT(v);
                                                 if (!isNaN(n) && n >= 0 && n <= 1) handleSaveRow(e.id, n, e.label, e.quantity, e.unitPrice);
                                             }}/>
                                    : <span className="ctcCellPhone">{(e.VAT * 100).toFixed(0)} %</span>
                                }
                            </td>
                            <td>
                                {editingRowId === e.id
                                    ? <input className="ctcInput" type="text" style={{width: 70}}
                                             value={currentQuantity}
                                             onChange={(ev) => {
                                                 const v = ev.target.value.replaceAll(',', '.');
                                                 const n = parseFloat(v);
                                                 setCurrentQuantity(v);
                                                 if (!isNaN(n)) handleSaveRow(e.id, e.VAT, e.label, n, e.unitPrice);
                                             }}/>
                                    : <span className="ctcCellPhone">{e.quantity}</span>
                                }
                            </td>
                            <td>
                                {editingRowId === e.id
                                    ? <input className="ctcInput" type="text" style={{width: 90}}
                                             value={currentUnitPrice}
                                             onChange={(ev) => {
                                                 const v = ev.target.value.replaceAll(',', '.');
                                                 const n = parseFloat(v);
                                                 setCurrentUnitPrice(v);
                                                 if (!isNaN(n)) handleSaveRow(e.id, e.VAT, e.label, e.quantity, n);
                                             }}/>
                                    : <span className="ctcCellPhone">{formatEuro(e.unitPrice)}</span>
                                }
                            </td>
                            <td><span className="ctcCellPhone">{formatEuro(e.totalAmountExclTax)}</span></td>
                            <td><span className="ctcCellName">{formatEuro(e.totalAmountInclTax)}</span></td>
                            <td>
                                <div className="ctcActions">
                                    {editingRowId === e.id
                                        ? <button type="button" className="ctcBtn ctcBtnConfirm" title="Valider"
                                                  onClick={() => setEditingRowId(null)}>
                                            <span className="material-symbols-outlined">check</span>
                                          </button>
                                        : <button type="button" className="ctcBtn ctcBtnEdit" title="Modifier"
                                                  onClick={() => {
                                                      setEditingRowId(e.id);
                                                      setCurrentLabel(e.label);
                                                      setCurrentVAT(e.VAT.toString().replaceAll(',', '.'));
                                                      setCurrentQuantity(e.quantity.toString().replaceAll(',', '.'));
                                                      setCurrentUnitPrice(e.unitPrice.toString().replaceAll(',', '.'));
                                                  }}>
                                            <span className="material-symbols-outlined">edit</span>
                                          </button>
                                    }
                                    <button type="button" className="ctcBtn ctcBtnDelete" title="Supprimer"
                                            onClick={() => delBillingItem(e)}>
                                        <span className="material-symbols-outlined">delete</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TableBillingItem;
